/**
 * This restriction adapter is for checking cube client side restrictions
 * Cube restrictions will be specified like this:
 *
 * cube://<Name>
 *
 * Note that each restriction resolution is cached and can only be cleared
 * by using clearCache().
 */

import dlv from 'dlv';
import jsonFetch from '@cube/utils/lib/json-fetch';

export const NAME = 'cube://(.+)$';

/**
 * Will store all pending and completed calls:
 */
let CACHE = {};

/**
 * Clear all cached restriction resolutions or
 * delete a specific one:
 * @param [String] restriction - An optional restriction to remove without clearing all.
 */
export function clearCache(restriction) {
	if (restriction) {
		delete CACHE[restriction];
	}
	else {
		CACHE = {};
	}
}

function trimSlash(url) {
	if (url && url.charAt(url.length - 1) === '/') {
		url = url.substr(0, url.length - 1);
	}

	return url;
}

export default function isAllowed(restriction, props) {
	if (!CACHE[restriction]) {
		let definedRestriction = dlv(props, `restrictions.${restriction.substring(7)}`);
		if (!definedRestriction) {
			CACHE[restriction] = false;
		}
		else {
			CACHE[restriction] = jsonFetch(`${trimSlash(props.locationServiceOrigin)}/ip/?fields=verbose`)
				.then(result => {
					if (result && result.city_name && result.postal_code) {
						console.log('MYZIP : ', result.postal_code);
						const foundIndex = definedRestriction.findIndex(dr =>
							((!dr.region || dr.region.indexOf(result.subdivision_1_iso_code) > -1) &&
								(!dr.city || dr.city.indexOf(result.city_name) > -1)) &&
							(!dr.ZIPS || dr.ZIPS.indexOf(result.postal_code) > -1)
						);
						CACHE[restriction] = foundIndex >= 0;
						return CACHE[restriction];
					}
					CACHE[restriction] = false;
					return CACHE[restriction];
				})
				.catch(() => {
					CACHE[restriction] = false;
					return CACHE[restriction];
				});
		}
	}
	return CACHE[restriction];
}
